// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const AlertSVG = styled(Icon).attrs({ viewBox: '0 0 300 300' })``;

const Alert = ({ color = navy, ...props }) => (
    <AlertSVG
        data-test="icon-alert"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M150 0C67.3 0 0 67.3 0 150s67.3 150 150 150 150-67.3 150-150S232.7 0 150 0zm-16.7 50h33.3v140h-33.3V50zM170 256.7h-40v-33.3h40v33.3z"
            fill={color}
        />
    </AlertSVG>
);

export { Alert as default, Alert };
